export const phoneNumberRegEx = (flags = 'gimu') => {
  return new RegExp(`(?:\\+|00)?\\s*(?:[3-4][0-9]|0)\\s*[1-9][0-9 -]{6,}`, flags)
}

export const emailRegEx = (flags = 'gimu') => {
  return new RegExp(`\\S+@\\S+\\.\\S+`, flags)
}

export const linksRegEx = (flags = 'gimu') => {
  return new RegExp(
    `(http[s]?:\\/\\/)?(\\w[\\w-]*)(\\.\\w[\\w-]*)+(\\/([\\w=-]+\\/)*[\\w=-]*(\\?[=&;,\\w-]*)?)?`,
    flags,
  )
}
